import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { useAuth } from "../contexts/AuthContext";
import { useSettings } from "../contexts/SettingsContext";
import { ArrowRight, Lock, GraduationCap } from "lucide-react";

export default function EnrollmentCTA({ size = "lg", variant = "primary", testId = "cta-request" }) {
  const { enrollmentOpen, loading } = useSettings();

  const baseClasses = size === "lg"
    ? "rounded-full px-7 h-12 text-base"
    : "rounded-full px-5 h-9 text-sm";

  const isPrimaryWhiteBg = variant === "white-on-blue";

  if (loading) {
    return <Button size={size} disabled className={`${baseClasses} bg-[#1E3A8A]/40 text-white`}>Chargement…</Button>;
  }

  if (!enrollmentOpen) {
    return (
      <Button
        size={size}
        disabled
        className={`${baseClasses} bg-[#E2E5EE] text-[#5c6374] hover:bg-[#E2E5EE] cursor-not-allowed`}
        data-testid={`${testId}-closed`}
      >
        <Lock className="w-4 h-4 mr-1.5" /> Formulaire de demande d'inscription fermé
      </Button>
    );
  }

  const cls = isPrimaryWhiteBg
    ? `${baseClasses} bg-white text-[#1E3A8A] hover:bg-[#FCFBF8]`
    : `${baseClasses} bg-[#1E3A8A] hover:bg-[#14265E] text-white`;

  return (
    <Link to="/demande-inscription" data-testid={testId}>
      <Button size={size} className={cls}>
        <span className="flex items-center">
          <span className="leading-tight">Formulaire de demande d'inscription</span>
          <ArrowRight className="ml-2 w-4 h-4" />
        </span>
      </Button>
    </Link>
  );
}

export function ReenrollmentCTA({ size = "lg", variant = "primary", testId = "cta-reenrollment" }) {
  const { reenrollmentOpen, loading } = useSettings();
  const { user } = useAuth();

  const baseClasses = size === "lg"
    ? "rounded-full px-7 h-12 text-base"
    : "rounded-full px-5 h-9 text-sm";

  const isPrimaryWhiteBg = variant === "white-on-blue";

  if (loading) {
    return <Button size={size} disabled className={`${baseClasses} bg-[#C86444]/40 text-white`}>Chargement…</Button>;
  }

  // Masqué quand les réinscriptions sont fermées
  if (!reenrollmentOpen) {
    return null;
  }

  // Si parent déjà connecté → va directement à la page réinscription
  // Sinon → connexion avec redirection
  const target = user?.role === "parent"
    ? "/parent/reinscription"
    : "/connexion?next=/parent/reinscription";

  const cls = isPrimaryWhiteBg
    ? `${baseClasses} bg-white/15 text-white border border-white/40 hover:bg-white/25 backdrop-blur-sm`
    : `${baseClasses} bg-[#C86444] hover:bg-[#A8533A] text-white`;

  return (
    <Link to={target} data-testid={testId}>
      <Button size={size} className={cls}>
        <GraduationCap className="mr-2 w-4 h-4" strokeWidth={1.5} />
        <span>
          <span className="block leading-tight">Demande de réinscription</span>
          <span className="block text-[10px] uppercase tracking-[0.18em] opacity-80 mt-0.5">Anciens élèves</span>
        </span>
      </Button>
    </Link>
  );
}
